// import React from "react";
// import {
//   Button,
//   InfoTimeCard,
//   NewTable,
// } from "../../../../../../../../components";
// import { dateFormator, mapTableRows } from "../../../../../../../../utils";

// const Deductions = () => {
//   const tableData = [];
//   const columns = [
//     { key: "deductionName", label: "Deduction Name" },
//     { key: "deductionType", label: "Deduction Type" },
//     { key: "deductionAmount", label: "Deduction Amount" },
//     { key: "employerContribution", label: "Employer Contribution" },
//     { key: "cycles", label: "Cycles" },
//   ];
//   const mappedRows = mapTableRows(tableData, columns);

//   const advancePaymenttableData = [
//     {
//       deductionName: "Pranathi Penmetcha Requral Payroll",
//       deductionType: "$ 865.00",
//       amount: "$ 865.00",
//       recovered: "$ 0.00",
//       Balance: "$ 0.00",
//       created: "2025-09-13T00:00:00.000Z",
//     },
//   ];
//   const advancePaymentColumns = [
//     {
//       key: "deductionName",
//       label: "Deduction Name",
//       render: (row) => (
//         <div className="flex gap-2 items-center justify-between">
//           {row.deductionName}
//           <Button type="icon" variant="text" icon="sms" size="xs" />
//         </div>
//       ),
//     },
//     { key: "deductionType", label: "Deduction Type" },
//     { key: "amount", label: "Amount" },
//     { key: "recovered", label: "Recovered" },
//     { key: "Balance", label: "Balance" },
//     {
//       key: "created",
//       label: "Created",
//       render: (row) => dateFormator(row.created, "month-day-year"),
//     },
//     {
//       key: "action",
//       label: "",
//       render: (row) => (
//         <div className="flex gap-2">
//           <Button
//             type="icon"
//             variant="text"
//             icon="stat_minus_1"
//             size="xs"
//             color="black"
//           />
//         </div>
//       ),
//     },
//   ];
//   const mappedRowsTwo = mapTableRows(
//     advancePaymenttableData,
//     advancePaymentColumns
//   );

//   return (
//     <div className="px-8 py-6">
//       <div>
//         <h6>Insurance Deductions included in this pay cycle</h6>

//         <div className="flex mt-6">
//           <InfoTimeCard
//             title="Insurance Deductions"
//             color="primary"
//             value={"0.00"}
//             prefix={"$"}
//             type2
//           />
//         </div>
//         <div className="my-6">
//           <NewTable rows={mappedRows} columns={columns} hideToolBar />
//         </div>
//         <h6>Select deductions to be included in this pay cycle</h6>
//         <div className="flex mt-6 mb-8">
//           <InfoTimeCard
//             title="Deductions"
//             color="primary"
//             value={"7,000.00"}
//             prefix={"$"}
//             type2
//           />
//         </div>
//         <NewTable
//           rows={mappedRowsTwo}
//           columns={advancePaymentColumns}
//           hideToolBar
//         />
//         <div className="flex justify-end mt-6 gap-4 items-end ">
//           <Button title="Hold" variant={"outlined"} />
//           <Button title="Save" />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Deductions;

/// before-----mahe change
// import React, { useEffect, useMemo, useState } from "react";
// import {
//   CustomInput,
//   InfoTimeCardAdv,
//   NewTable,
//   NewTableAdv,
//   PageHeader,
//   PageTitle,
// } from "../../../../../../../../components";
// import { v4 as uuidv4 } from "uuid";

// import { mapTableRows } from "../../../../../../../../utils";
// import RegularDeductionCollapse from "./Dedections/RegularDeductionCollapse";
// import { useDispatch, useSelector } from "react-redux";
// import { getAllEmpDeductions, setCurrentPayrollEditing } from "../../../../../../../../redux/slices/payroll/payrollSlice";

// const Deductions = () => {
//   const dispatch=useDispatch()
//    const { currentPayrollEditing,loading, empDeduction } = useSelector((state) => state.payRoll);

//      const empDeductions = empDeduction?.data || [];
//      console.log("currentPayrollEditing",currentPayrollEditing);

//   const employeeId = currentPayrollEditing?.employeeId?.[0]?.uiid;
//   const [tableData, setTableData] = useState([
//     // {
//     //   deductionType: "Dental Check",
//     //   schedule: "06/01/2025 - 06/30/2025",
//     //   deductionAmount: "$ 1500",
//     //   deductionAmountInput: "$1500",
//     // },
//   ]);
// const deductions = Array.isArray(empDeductions) ? empDeductions : [];

//  const groupedDeductions = useMemo(() => {
//     return deductions.reduce((acc, deduction) => {
//       const deductionType = Number(deduction.deductionType);
//       if (!acc[deductionType]) acc[deductionType] = [];
//       acc[deductionType].push(deduction);
//       return acc;
//     }, {});
//   }, [deductions]);

// const regularInsurance = groupedDeductions[1] || [];
// const healthInsurance = groupedDeductions[2] || [];
// const regularH1bInsurance = Array.isArray(groupedDeductions[1])
//   ? groupedDeductions[1].filter(item =>
//       item.name?.toLowerCase() === "h1b"
//     )
//   : [];

// // Flatten and collect all documents from those filtered H1B items
// const h1bDocuments = regularH1bInsurance.flatMap(item =>
//   Array.isArray(item.documents) ? item.documents : []
// );

// console.log('Health Insurance:', healthInsurance);
// console.log('Regular H1B Insurance:', regularH1bInsurance);
// // const healthInsuranceFilter = (Array.isArray(healthInsurance) ? healthInsurance : [])
// //   .flatMap(data =>
// //     Array.isArray(data.installments) ?
// //       data.installments.map(installment => ({ ...installment,id: installment._id,deducted:data?.amounts?.deducted, uiid:data.uiid,name:data.name,deductionAmountInput:installment.receivable }))
// //       : []
// //   );
// // const h1bInsuranceFilter = (Array.isArray(regularH1bInsurance) ? regularH1bInsurance : [])
// //   .flatMap(data =>
// //     Array.isArray(data.installments) ?
// //       data.installments.map(installment => ({ ...installment,id: installment._id,deducted:data?.amounts?.deducted, uiid:data.uiid,name:data.name,deductionAmountLelf:installment.receivable }))
// //       : []
// //   );
// const healthInsuranceFilter = useMemo(() => {
//   return Array.isArray(healthInsurance)
//     ? healthInsurance.flatMap(data =>
//         Array.isArray(data.installments)
//           ? data.installments.map(installment => ({
//               ...installment,
//               id: installment._id,
//               deducted: data?.amounts?.deducted,
//               uiid: data.uiid,
//               name: data.name,
//               deductionAmountInput: installment.receivable
//             }))
//           : []
//       )
//     : [];
// }, [healthInsurance]);

// const h1bInsuranceFilter = useMemo(() => {
//   return Array.isArray(regularH1bInsurance)
//     ? regularH1bInsurance.flatMap(data =>
//         Array.isArray(data.installments)
//           ? data.installments.map(installment => ({
//               ...installment,
//               id: installment._id,
//               deducted: data?.amounts?.deducted,
//               uiid: data.uiid,
//               name: data.name,
//               deductionAmountLelf: installment.receivable
//             }))
//           : []
//       )
//     : [];
// }, [regularH1bInsurance]);
// // Now access your filtered lists easily:
// // Example logs to verify

//   const columns = [
//     {
//       key: "name",
//       label: "Deduction Type",
//     },
//     { key: "payCycle", label: "Schedule" },
//     { key: "deducted", label: "Deduction Amount" },
//     {
//       key: "deductionAmountInput",
//       label: "",
//       render: (row) => (
//         <div>
//           <CustomInput
//             type="text"
//             placeholder=""
//             title=""
//             size={"sm"}
//             value={row?.deductionAmountInput}
//             onChange={(e) => handleChangeTable("deductionAmountInput", row, e)}
//             disabled={true}
//           />
//         </div>
//       ),
//     },
//   ];
//   // const mappedRows = mapTableRows(tableData, columns);
//   // const tableDataRegular = [
//   const [tableData2, setTableData2] = useState([
//     // {
//     //   id: uuidv4(),
//     //   deductionType: "Schedule - 13",
//     //   schedule: "06/01/2025 - 06/30/2025",
//     //   deductionAmount: "$ 500.00",
//     //   deductionAmountLelf: "$ 2,500",
//     // },
//     // {
//     //   id: uuidv4(),
//     //   deductionType: "Schedule - 14",
//     //   schedule: "06/01/2025 - 06/30/2025",
//     //   deductionAmount: "$ 500.00",
//     //   deductionAmountLelf: "$ 2,500",
//     // },
//     // {
//     //   id: uuidv4(),
//     //   deductionType: "Schedule - 15",
//     //   schedule: "06/01/2025 - 06/30/2025 ",
//     //   deductionAmount: "$ 500.00",
//     //   deductionAmountLelf: "$ 2,500",
//     // },
//     // {
//     //   id: uuidv4(),
//     //   deductionType: "Schedule - 16",
//     //   schedule: "06/01/2025 - 06/30/2025",
//     //   deductionAmount: "$ 500.00",
//     //   deductionAmountLelf: "$ 2,500",
//     // },
//   ]);
//   const columnsRegular = [
//     {
//       key: "schedule",
//       label: "Deduction Type",
//       showAccordianBtn: true,
//     },
//     { key: "payCycle", label: "Schedule", showAccordianBtn: true },
//     { key: "deducted", label: "Deduction Amount" },
//     {
//       key: "deductionAmountLelf",
//       label: "",
//       render: (row) => (
//         <div>
//           <CustomInput
//             type="text"
//             placeholder=""
//             title=""
//             size={"sm"}
//             value={row?.deductionAmountLelf}
//             onChange={(e) => handleChangeTable("deductionAmountLelf", row, e)}
//             // disabled={true}
//           />
//         </div>
//       ),
//     },
//   ];
//   // const mappedRowsRegular = mapTableRows(tableDataRegular, columnsRegular);

//   const [tableData3, setTableData3] = useState([
//     // {
//     //   id: uuidv4(),
//     //   deductionType: "Schedule - 13",
//     //   schedule: "06/01/2025 - 06/30/2025",
//     //   deductionAmount: "$ 500",
//     //   deductionAmountInput: "$2500",
//     // },
//     // {
//     //   id: uuidv4(),
//     //   deductionType: "Schedule - 14",
//     //   schedule: "06/01/2025 - 06/30/2025",
//     //   deductionAmount: "$ 500",
//     //   deductionAmountInput: "$2500",
//     // },
//     // {
//     //   id: uuidv4(),
//     //   deductionType: "Schedule - 15",
//     //   schedule: "06/01/2025 - 06/30/2025",
//     //   deductionAmount: "$ 500",
//     //   deductionAmountInput: "$2500",
//     // },
//     // {
//     //   id: uuidv4(),
//     //   deductionType: "Schedule - 16",
//     //   schedule: "06/01/2025 - 06/30/2025",
//     //   deductionAmount: "$ 500",
//     //   deductionAmountInput: "$2500",
//     // },
//   ]);
//   const columns3 = [
//     {
//       key: "deductionType",
//       label: "Deduction Type",
//     },
//     {
//       key: "schedule",
//       label: "Schedule",
//       render: (row) => <div>{row.deductionType} <span className="">
//         </span></div>,
//     },
//     { key: "deductionAmount", label: "Deduction Amount" },
//     {
//       key: "deductionAmountInput",
//       label: "",
//       showAccordianBtn: true,
//       render: (row) => (
//         <div>
//           <CustomInput
//             type="text"
//             placeholder=""
//             title=""
//             size={"sm"}
//             value={row?.deductionAmountInput}
//             onChange={(e) => handleChangeTable("deductionAmountInput", row, e)}
//             // disabled={true}
//           />
//         </div>
//       ),
//     },
//   ];

//   const handleChangeTable = (field, row, value) => {
//     setTableData((prev) =>
//       prev.map((item) =>
//         item.id === row.id ? { ...item, [field]: value } : item
//       )
//     );
//     setTableData2((prev) =>
//       prev.map((item) =>
//         item.id === row.id ? { ...item, [field]: value } : item
//       )
//     );
//     setTableData3((prev) =>
//       prev.map((item) =>
//         item.id === row.id ? { ...item, [field]: value } : item
//       )
//     );
//   };
// console.log("employeeId",employeeId);
//   useEffect(()=>{
//     const handleCallApi=async()=>{
//     if(employeeId){
//     const filters={  "type": { "type": "NONE", "value": 1 },"employeeId": { "type": "NONE", "value": employeeId }}
// dispatch(
//       getAllEmpDeductions({
//         coll: "EmpDeduction",
//         filters
//       })
//     );
//   }
//     }
// handleCallApi()
//   },[])
//   console.log("h1bInsuranceFilter",h1bInsuranceFilter);
//   useEffect(()=>{
//      if(h1bInsuranceFilter.length>0&&tableData2.length===0){
//       setTableData2(h1bInsuranceFilter)
//      }
//      if(healthInsuranceFilter.length>0&&tableData.length===0){
//       setTableData(healthInsuranceFilter)
//      }
//   },[h1bInsuranceFilter,healthInsuranceFilter])
//   console.log("helo");
//     // const deductions=currentPayrollEditing?.deductions

// const handleSelectDeductions = (field, value = []) => {
//   const source =
//     field === "health" ? healthInsuranceFilter :
//     field === "h1b" ? h1bInsuranceFilter :
//     [];

//   const reduxDeductions = currentPayrollEditing?.deductions || [];

//   const selectedItems = source.filter(item =>
//     value.includes(item?.uiid) || value.includes(item?.id)
//   );

//   const reduxItems = source.filter(item =>
//     reduxDeductions.includes(item?.uiid) || reduxDeductions.includes(item?.id)
//   );

//   const combinedItems = [...selectedItems, ...reduxItems];

//   const seen = new Set();
//   const uniqueItems = combinedItems.filter(item => {
//     const key = item?.uiid || item?.id;
//     if (seen.has(key)) return false;
//     seen.add(key);
//     return true;
//   });

//   const oldIds = (reduxDeductions || []).map(d => d?.uiid || d?.id).sort();
//   const newIds = uniqueItems.map(d => d?.uiid || d?.id).sort();

//   // Compare and skip dispatch if values didn’t change
//   const hasChanged = JSON.stringify(oldIds) !== JSON.stringify(newIds);

//   if (hasChanged) {
//     dispatch(
//       setCurrentPayrollEditing({
//         ...currentPayrollEditing,
//         deductions: uniqueItems
//       })
//     );
//   }
// };

//   return (
//     <div className="p-4">
//       <div className="mt-3">
//         <PageHeader
//           Section={
//             <div className="flex">
//               <PageTitle title={"Health Insurance"} />
//             </div>
//           }
//           RightSection={
//             <div>
//               <InfoTimeCardAdv
//                 title="Insurance Deductions"
//                 color="primary"
//                 value={"$ 0.00"}
//                 prefix={""}
//                 type2
//               />
//             </div>
//           }
//         />
//         <div className="mt-2">
//           <NewTableAdv
//             showCheckbox
//             rows={tableData}
//             columns={columns}
//               onSelectionChange={(value) => {
//   const existingDeductions = currentPayrollEditing?.deductions || [];
//   // Avoid dispatch if both selected and redux deductions are empty
//   if (value.length === 0 && existingDeductions.length === 0) return;
//   handleSelectDeductions("health", value);
// }}

//             hideToolBar
//           />
//         </div>
//         <div className="mt-4">
//           <PageHeader
//             Section={
//               <div className="flex">
//                 <PageTitle title={"Regular Deductions"} />
//               </div>
//             }
//             RightSection={
//               <div>
//                 <InfoTimeCardAdv
//                   title="Deductions"
//                   color="primary"
//                   value={"$ 7,000.00"}
//                   prefix={""}
//                   type2
//                 />
//               </div>
//             }
//           />
//         </div>
//         <div className="flex">
//           <PageTitle title={"H1B"} tag="h6" />
//         </div>
//         <div className="mt-3">
//           <NewTableAdv
//             showCheckbox
//             rows={tableData2}
//             columns={columnsRegular}
//             // accrodian={""}
//             hideToolBar
//                 onSelectionChange={(value) => {
//   const existingDeductions = currentPayrollEditing?.deductions || [];
//   // Avoid dispatch if both selected and redux deductions are empty
//   if (value.length === 0 && existingDeductions.length === 0) return;
//   handleSelectDeductions("h1b", value);
// }}

//             // showAccordianBtn={true}
//           />
//         </div>
//         <div className="flex mt-4">
//           <PageTitle title={"GC"} tag="h6" />
//         </div>
//         <div className="mt-1">
//           <NewTableAdv
//             showCheckbox
//             rows={tableData3}
//             columns={columns3}
//             // accrodian={<RegularDeductionCollapse/>}
//             hideToolBar
//             showAccordianBtn
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Deductions;

////////////////////////////working code\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
////////////////////////////working code\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
////////////////////////////working code\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
////////////////////////////working code\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
////////////////////////////working code\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
////////////////////////////working code\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

// import React, { useEffect, useMemo, useState } from "react";
// import {
//   CustomInput,
//   InfoTimeCardAdv,
//   NewTable,
//   NewTableAdv,
//   PageHeader,
//   PageTitle,
// } from "../../../../../../../../components";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   getAllEmpDeductions,
//   setCurrentPayrollEditing,
// } from "../../../../../../../../redux/slices/payroll/payrollSlice";
// import { formatCurrency } from "../../../../../../../../utils/stringUtils";
// import { fetchEmpDeduction } from "../../../../../../../../redux/slices/payroll/payrollApi";
// import { showToastMessage } from "../../../../../../../../utils/toastUtil";
// import dayjs from "dayjs";
// import common from "../../../../../../../../utils/common";
// const Deductions = ({ rowData, disableEditing }) => {
//   const { parseAmount } = common;
//   // console.log("rowData", rowData);
//   const dispatch = useDispatch();
//   useEffect(() => {
//     dispatch(
//       setCurrentPayrollEditing({
//         tabswitched: true,
//       })
//     );
//   }, []);
//   const { currentPayrollEditing, empDeduction } = useSelector(
//     (state) => state.payRoll
//   );

//   const employeeId = currentPayrollEditing?.employeeId?.uiid;
//   // const empDeductions = empDeduction?.data || [];
//   const [empDeductions, setEmpDeductions] = useState([]);
//   const [tableData, setTableData] = useState([]);
//   const [tableData2, setTableData2] = useState([]);
//   const [tableData3, setTableData3] = useState([]);
//   const [selectedHealthIds, setSelectedHealthIds] = useState([]);
//   const [selectedH1bIds, setSelectedH1bIds] = useState([]);
//   const deductions = Array.isArray(empDeductions) ? empDeductions : [];
//   const reduxDeductions = currentPayrollEditing?.deductions || [];
//   const reduxEmpDeductions = currentPayrollEditing?.empDeductions || [];
//   // console.log("reduxEmpDeductions", reduxEmpDeductions);
//   // console.log("reduxDeductions", reduxDeductions);
//   const selectedDeductionIdsH1b =
//     reduxDeductions
//       .filter((deduction) => deduction?.deductionType === 1)
//       .map((deduction) => deduction?._id) || [];

//   // Health deductions (deductionType === 2)
//   const selectedDeductionIdsHealth =
//     reduxDeductions
//       .filter((deduction) => deduction?.deductionType === 2)
//       .map((deduction) => deduction?._id) || [];
//   const groupedDeductions = useMemo(() => {
//     return deductions.reduce((acc, deduction) => {
//       const deductionType = Number(deduction.deductionType);
//       if (!acc[deductionType]) acc[deductionType] = [];
//       acc[deductionType].push(deduction);
//       return acc;
//     }, {});
//   }, [deductions]);

//   const regularInsurance = groupedDeductions[1] || [];
//   const healthInsurance = groupedDeductions[2] || [];

//   const regularH1bInsurance = regularInsurance;
//   // const regularH1bInsurance = regularInsurance.filter(
//   //   (item) => item.name?.toLowerCase() === "h1b"
//   // );

//   const healthInsuranceFilter = useMemo(() => {
//     return healthInsurance.flatMap((data) =>
//       Array.isArray(data.installments)
//         ? data.installments.map((installment) => ({
//             ...installment,
//             id: installment._id,
//             deducted: installment.receivable,
//             uiid: data.uiid,
//             name: data.name,
//             deductionAmountInput:
//               installment.receivableExachange ??
//               installment.received ??
//               installment.receivable,
//             deductionType: data?.deductionType,
//           }))
//         : []
//     );
//   }, [healthInsurance]);

//   const h1bInsuranceFilter = useMemo(() => {
//     return regularH1bInsurance.flatMap((data) =>
//       Array.isArray(data.installments)
//         ? data.installments.map((installment) => ({
//             ...installment,
//             id: installment._id,
//             deducted: installment.receivable,
//             uiid: data.uiid,
//             name: data.name,
//             deductionAmountLelf:
//               installment.receivableExachange ??
//               installment.received ??
//               installment.receivable,
//             deductionType: data?.deductionType,
//           }))
//         : []
//     );
//   }, [regularH1bInsurance]);

//   const columns = [
//     { key: "name", label: "Deduction Type" },
//     // { key: "payCycle", label: "Schedule" },
//     { key: "deducted", label: "Deduction Amount" },
//     {
//       key: "deductionAmountInput",
//       label: "",
//       render: (row) => (
//         <CustomInput
//           type="number"
//           size="sm"
//           value={row?.deductionAmountInput}
//           onChange={(e) => handleChangeTable("deductionAmountInput", row, e)}
//           disabled
//           maxNumber={row?.deducted}
//         />
//       ),
//     },
//   ];

//   const columnsRegular = [
//     { key: "name", label: "Deduction Type", showAccordianBtn: true },
//     // { key: "payCycle", label: "Schedule", showAccordianBtn: true },
//     { key: "deducted", label: "Deduction Amount" },
//     {
//       key: "deductionAmountLelf",
//       label: "",
//       render: (row) => (
//         <div className="flex items-center max-w-[100px]">
//           <CustomInput
//             type="number"
//             size="sm"
//             value={row?.deductionAmountLelf}
//             onChange={(e) => handleChangeTable("deductionAmountLelf", row, e)}
//             maxNumber={row?.deducted}
//           />
//         </div>
//       ),
//     },
//   ];

//   const columns3 = [
//     { key: "deductionType", label: "Deduction Type" },
//     {
//       key: "schedule",
//       label: "Schedule",
//       render: (row) => <div>{row.deductionType}</div>,
//     },
//     { key: "deductionAmount", label: "Deduction Amount" },
//     {
//       key: "deductionAmountInput",
//       label: "",
//       showAccordianBtn: true,
//       render: (row) => (
//         <CustomInput
//           type="text"
//           size="sm"
//           value={row?.deductionAmountInput}
//           onChange={(e) => handleChangeTable("deductionAmountInput", row, e)}
//         />
//       ),
//     },
//   ];

//   const handleChangeTable = (field, row, e) => {
// try {
//       const value = e?.target?.value ?? e;
//       // Update tableData (health deductions)
//       setTableData((prev) =>
//         prev.map((item) =>
//           item.id === row.id ? { ...item, [field]: value } : item
//         )
//       );

//       // Update tableData3 (if used)
//       setTableData3((prev) =>
//         prev.map((item) =>
//           item.id === row.id ? { ...item, [field]: value } : item
//         )
//       );

//       // ✅ Update empDeductions for matching installment._id
//       const updatedEmpDeductions = empDeductions.map((deduction) => {
//         if (!Array.isArray(deduction.installments)) return deduction;

//         const updatedInstallments = deduction.installments.map((installment) =>
//           installment._id === row.id
//             ? {
//                 ...installment,
//                 receivableExachange: value, // assuming 'receivable' is the field you're updating
//               }
//             : installment
//         );

//         return {
//           ...deduction,
//           installments: updatedInstallments,
//         };
//       });

//       setEmpDeductions(updatedEmpDeductions);

//       // Handle H1B table updates specifically
//       if (field === "deductionAmountLelf") {
//         const updatedTableData2 = tableData2.map((item) =>
//           item.id === row.id ? { ...item, [field]: value } : item
//         );
//         setTableData2(updatedTableData2);

//         const isAvailable = selectedDeductionIdsH1b.includes(row._id || row.id);
//         if (isAvailable) {
//           handleSelectDeductions(
//             "h1b",
//             selectedDeductionIdsH1b,
//             updatedTableData2,
//             updatedEmpDeductions
//           );
//         }
//       }
// } catch (error) {
//   console.error("Error in handleChangeTable:", error);
// }
//   };

//   const handleCallDeductions = async () => {
//     try {
//       if (!employeeId || !rowData?.payCycle?.from || !rowData?.payCycle?.to) {
//         console.warn("Missing required filter parameters");
//         return;
//       }
//       // console.log("Filters:", {
//       //   employeeId,
//       //   type: 1,
//       //   stop: false,
//       //   from: rowData?.payCycle?.from,
//       //   to: rowData?.payCycle?.to,
//       // });
//       let employeeIdToCall =
//         rowData?.employeeId?.employmentType === 4
//           ? rowData?.employeeId?.linkedTo
//           : rowData?.employeeId?.uiid;

//       const params = {
//         coll: "EmpDeduction",
//         filters: {
//           // employeeId: { type: "NONE", value: employeeId },
//           employeeId: { type: "NONE", value: employeeIdToCall },
//           type: { type: "NONE", value: 1 },
//           stop: { type: "NONE", value: false },
//           "installments.payCycle.from": {
//             type: "GTE",
//             value: dayjs(rowData?.payCycle?.from)
//               .startOf("month")
//               .toISOString(),
//           },
//           "installments.payCycle.to": {
//             type: "LTE",
//             value: dayjs(rowData?.payCycle?.to).endOf("month").toISOString(),
//           },
//         },
//       };

//       const response = await fetchEmpDeduction(params);

//       if (response.success) {
//         const data = response?.data?.data || [];
//         const filteredData = response.data.data
//           .map((deduction) => {
//             // Find all installments that overlap filter range
//             const matchedInstallments = deduction.installments.filter(
//               (inst) => {
//                 const from = new Date(inst.payCycle.from);
//                 const to = new Date(inst.payCycle.to);
//                 const filterFrom = new Date(rowData.payCycle.from);
//                 const filterTo = new Date(rowData.payCycle.to);

//                 return from <= filterTo && to >= filterFrom;
//               }
//             );
//             if (matchedInstallments.length === 0) return null;
//             return {
//               ...deduction,
//               installments: matchedInstallments, // only matched installments kept here
//             };
//           })
//           .filter(Boolean); // remove nulls
//         const healthDeductions = filteredData.filter(
//           (d) => d.deductionType === 2
//         );
//         const dataHealth = healthDeductions.flatMap((data) =>
//           Array.isArray(data.installments)
//             ? data.installments.map((installment) => ({
//                 ...installment,
//                 id: installment._id,
//                 deducted: installment.receivable,
//                 uiid: data.uiid,
//                 name: data.name,
//                 deductionAmountInput: installment.receivable,
//                 deductionType: data?.deductionType,
//               }))
//             : []
//         );
//         const allInstallmentIds = healthDeductions
//           .flatMap((d) => d.installments)
//           .map((inst) => inst._id);
//         setEmpDeductions(filteredData);
//         if (reduxDeductions.length === 0) {
//           handleSelectDeductions("health", allInstallmentIds, dataHealth);
//         }
//         // Your logic here
//       } else {
//         setEmpDeductions([]);
//         // Alternative logic
//       }
//     } catch (error) {
//       console.error("Error fetching deductions:", error);
//       showToastMessage("error", "COMMON.UNKNOWN_ERROR");
//     }
//   };

//   useEffect(() => {
//     if (!employeeId) return;
//     // handleCallDeductions();
//     if (reduxEmpDeductions.length > 0) {
//       setEmpDeductions(reduxEmpDeductions);
//       return;
//     } else {
//       handleCallDeductions();
//     }
//   }, [employeeId, dispatch]);

//   useEffect(() => {
//     if (h1bInsuranceFilter.length && tableData2.length === 0) {
//       setTableData2(h1bInsuranceFilter);
//     }
//     if (healthInsuranceFilter.length && tableData.length === 0) {
//       setTableData(healthInsuranceFilter);
//     }
//   }, [h1bInsuranceFilter, healthInsuranceFilter]);

//   //   const handleSelectDeductions = (field, value = [],data=[]) => {
//   //     let source = [];
//   // if (data?.length > 0) {
//   //   source = data;
//   // } else if (field === "health") {
//   //   source = tableData;
//   // } else if (field === "h1b") {
//   //   source = tableData2;
//   // }
//   // console.log("data",data);
//   //     const selectedIds = value.map((v) => String(v)); // normalize as string
//   //     const selectedMap = new Map();
//   //     // Add selected items from source (newly selected or retained)
//   //     for (let item of source) {
//   //       const itemId = String(item?.id || item?.uiid);
//   //       if (selectedIds.includes(itemId)) {
//   //         selectedMap.set(itemId, item);
//   //       }
//   //     }

//   //     // Retain items from previous Redux deductions that are not from the current source OR still selected
//   //     for (let item of reduxDeductions) {
//   //       const itemId = String(item?.id || item?.uiid);
//   //       const isFromSource = source.some(
//   //         (s) => String(s?.id || s?.uiid) === itemId
//   //       );

//   //       if (!isFromSource || selectedIds.includes(itemId)) {
//   //         selectedMap.set(itemId, item); // ensure final structure matches original
//   //       }
//   //     }
//   //     const finalDeductions = Array.from(selectedMap.values());

//   //     // Detect change
//   //     const oldIds = reduxDeductions.map((d) => d?.id || d?.uiid).sort();
//   //     const newIds = finalDeductions.map((d) => d?.id || d?.uiid).sort();
//   //     const hasChanged = JSON.stringify(oldIds) !== JSON.stringify(newIds);
//   //     console.log("hasChanged",hasChanged);
//   //     if (hasChanged) {
//   //       // Total of selected deductions
//   //       // const totalDeductionsAmount = finalDeductions.reduce(
//   //       //   (sum, item) =>
//   //       //     sum + (item.deductionAmountInput || item.deductionAmountLelf || 0),
//   //       //   0
//   //       // );
//   //       const totalDeductionsAmount = finalDeductions.reduce((sum, item) => {
//   //   const amount = parseAmount(item.deductionAmountInput ?? item.deductionAmountLelf);
//   //   return sum + amount;
//   // }, 0);
//   //       // const oldDeductionamount = reduxDeductions.reduce(
//   //       //   (sum, item) =>
//   //       //     sum + (item.deductionAmountInput || item.deductionAmountLelf || 0),
//   //       //   0
//   //       // );
//   //       const oldDeductionAmount = reduxDeductions.reduce((sum, item) => {
//   //   const amount = parseAmount(item.deductionAmountInput ?? item.deductionAmountLelf);
//   //   return sum + amount;
//   // }, 0);
//   //       const baseAmount =(currentPayrollEditing?.totalAmount || 0) + (oldDeductionAmount || 0);
//   //       const difference =
//   //         (currentPayrollEditing?.difference || 0) - (oldDeductionAmount || 0);
//   //         console.log("totalDeductionsAmount",totalDeductionsAmount);
//   //       dispatch(
//   //         setCurrentPayrollEditing({
//   //           ...currentPayrollEditing,
//   //           deductions: finalDeductions,
//   //           // totalAmount:baseAmount-totalDeductionsAmount,
//   //           difference: difference + totalDeductionsAmount,
//   //           totalDeductionsAmount: totalDeductionsAmount,
//   //         })
//   //       );
//   //     }
//   //   };
//   const handleSelectDeductions = (
//     field,
//     value = [],
//     data = [],
//     updateEmp = []
//   ) => {
//     let source = [];

//     if (data?.length > 0) {
//       source = data;
//     } else if (field === "health") {
//       source = tableData;
//     } else if (field === "h1b") {
//       source = tableData2;
//     }

//     const selectedIds = value.map((v) => String(v)); // Normalize all IDs to string
//     const selectedMap = new Map();
//     for (let item of source) {
//       const itemId = String(item?.id || item?.uiid);
//       if (selectedIds.includes(itemId)) {
//         selectedMap.set(itemId, item);
//       }
//     }
//     for (let item of reduxDeductions) {
//       const itemId = String(item?.id || item?.uiid);
//       const isFromSource = source.some(
//         (s) => String(s?.id || s?.uiid) === itemId
//       );

//       if (!isFromSource || selectedIds.includes(itemId)) {
//         if (!selectedMap.has(itemId)) {
//           selectedMap.set(itemId, item);
//         }
//       }
//     }
//     // ✅ Replace any item with updated amount if different
//     const finalDeductions = Array.from(selectedMap.values()).map((item) => {
//       const itemId = String(item?.id || item?.uiid);
//       const existing = reduxDeductions.find(
//         (d) => String(d?.id || d?.uiid) === itemId
//       );
//       if (existing) {
//         const oldAmount = parseAmount(
//           existing.deductionAmountInput ?? existing.deductionAmountLelf
//         );
//         const newAmount = parseAmount(
//           item.deductionAmountInput ?? item.deductionAmountLelf
//         );

//         if (oldAmount !== newAmount) {
//           return item; // amount changed — use new
//         } else {
//           return existing; // amount same — reuse
//         }
//       }
//       return item; // new item — add
//     });

//     // ✅ Detect changes in deductions (IDs or amounts)
//     const oldMap = new Map(
//       reduxDeductions.map((d) => [String(d?.id || d?.uiid), d])
//     );
//     const newMap = new Map(
//       finalDeductions.map((d) => [String(d?.id || d?.uiid), d])
//     );

//     let hasChanged = false;

//     if (oldMap.size !== newMap.size) {
//       hasChanged = true;
//     } else {
//       for (const [id, oldItem] of oldMap.entries()) {
//         const newItem = newMap.get(id);
//         if (!newItem) {
//           hasChanged = true;
//           break;
//         }

//         const oldAmount = parseAmount(
//           oldItem.deductionAmountInput ?? oldItem.deductionAmountLelf
//         );
//         const newAmount = parseAmount(
//           newItem.deductionAmountInput ?? newItem.deductionAmountLelf
//         );

//         if (oldAmount !== newAmount) {
//           hasChanged = true;
//           break;
//         }
//       }
//     }

//     // ✅ Dispatch only if something changed
//     if (hasChanged) {
//       const totalDeductionsAmount = finalDeductions.reduce((sum, item) => {
//         const amount = parseAmount(
//           item.deductionAmountInput ?? item.deductionAmountLelf
//         );
//         return sum + amount;
//       }, 0);

//       const oldDeductionAmount = reduxDeductions.reduce((sum, item) => {
//         const amount = parseAmount(
//           item.deductionAmountInput ?? item.deductionAmountLelf
//         );
//         return sum + amount;
//       }, 0);

//       const baseAmount =
//         (currentPayrollEditing?.totalAmount || 0) + (oldDeductionAmount || 0);
//       const difference =
//         (currentPayrollEditing?.difference || 0) - (oldDeductionAmount || 0);

//       dispatch(
//         setCurrentPayrollEditing({
//           ...currentPayrollEditing,
//           deductions: finalDeductions,
//           difference: difference + totalDeductionsAmount,
//           totalDeductionsAmount,
//           empDeductions: updateEmp.length > 0 ? updateEmp : empDeductions,
//         })
//       );
//     }
//   };

//   const filteredData = reduxDeductions
//     .filter(
//       (data) =>
//         data.deductionType === 2 &&
//         data.deductionAmountInput !== undefined &&
//         data.deductionAmountInput !== null &&
//         data.deductionAmountInput !== ""
//     )
//     .map((data) => data.deductionAmountInput); // Extracts deductionAmountInput from each filtered item
//   const totalDeduction = filteredData.reduce((acc, amount) => {
//     return typeof amount === "number" ? acc + amount : acc;
//   }, 0);

//   const filteredDataH1b = reduxDeductions
//     .filter(
//       (data) =>
//         data.deductionType === 1 &&
//         data.deductionAmountLelf !== undefined &&
//         data.deductionAmountLelf !== null &&
//         data.deductionAmountLelf !== ""
//     )
//     .map((data) => data.deductionAmountLelf); // Extracts deductionAmountInput from each filtered item
//   const totalDeductionH1b = filteredDataH1b.reduce((acc, amount) => {
//     // Ensure that each amount is a valid number
//     return typeof amount === "number" ? acc + amount : acc;
//   }, 0);
//   // H1B deductions (deductionType === 1)

//   return (
//     <div className="p-4">
//       <div className="mt-3">
//         <PageHeader
//           Section={<PageTitle title="Health Insurance" />}
//           RightSection={
//             <InfoTimeCardAdv
//               title="Insurance Deductions"
//               color="primary"
//               value={formatCurrency(totalDeduction)}
//               type2
//             />
//           }
//         />
//         <div className="mt-2">
//           <NewTableAdv
//             showCheckbox
//             rows={tableData}
//             columns={columns}
//             hideToolBar
//             disableSelection={disableEditing}
//             defaultCheckBox={true}
//             defaultSelectedRows={selectedDeductionIdsHealth}
//             onSelectionChange={(value) => {
//               const sortedNew = [...value].sort();
//               const sortedOld = [...selectedHealthIds].sort();
//               if (JSON.stringify(sortedNew) !== JSON.stringify(sortedOld)) {
//                 setSelectedHealthIds(value);
//                 // console.log("value", value);
//                 handleSelectDeductions("health", value);
//               }
//             }}
//           />
//         </div>

//         <div className="mt-4">
//           <PageHeader
//             Section={<PageTitle title="Regular Deductions" />}
//             RightSection={
//               <InfoTimeCardAdv
//                 title="Deductions"
//                 color="primary"
//                 value={formatCurrency(totalDeductionH1b)}
//                 type2
//               />
//             }
//           />
//         </div>

//         <div className="flex">{/* <PageTitle title="H1B" tag="h6" />  */}</div>
//         <div className="mt-3">
//           {/* <NewTableAdv
//             showCheckbox
//             rows={tableData2}
//             columns={columnsRegular}
//             hideToolBar
//             defaultSelectedRows={selectedDeductionIdsH1b}
//             disableSelection={disableEditing}
//             onSelectionChange={(value) => {
//               const sortedNew = [...value].sort();
//               const sortedOld = [...selectedH1bIds].sort();
//               if (JSON.stringify(sortedNew) !== JSON.stringify(sortedOld)) {
//                 setSelectedH1bIds(value);
//                 // console.log("value", value);
//                 handleSelectDeductions("h1b", value);
//               }
//             }}
//           /> */}

//           {/* eplace with another table because newTableAdv chckbox is not working */}
//           <NewTable
//             showCheckbox
//             // rows={h1bTableData}
//             rows={tableData2}
//             columns={columnsRegular}
//             hideToolBar
//             defaultSelectedRows={selectedDeductionIdsH1b}
//             disableSelection={disableEditing}
//             onSelectionChange={(value) => {
//               const sortedNew = [...value].sort();
//               const sortedOld = [...selectedH1bIds].sort();
//               if (JSON.stringify(sortedNew) !== JSON.stringify(sortedOld)) {
//                 setSelectedH1bIds(value);
//                 // console.log("value", value);
//                 handleSelectDeductions("h1b", value);
//               }
//             }}
//             toolbarRight={{
//               search: false,
//               filter: false,
//               download: false,
//             }}
//           />
//         </div>

//         {/* <div className="flex mt-4">
//           <PageTitle title="GC" tag="h6" />
//         </div>
//         <div className="mt-1">
//           <NewTableAdv
//             showCheckbox
//             rows={tableData3}
//             columns={columns3}
//             hideToolBar
//             showAccordianBtn
//           />
//         </div> */}
//       </div>
//     </div>
//   );
// };

// export default Deductions;

////////////////////////////testing code\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
////////////////////////////testing code\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
////////////////////////////testing code\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
////////////////////////////testing code\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
////////////////////////////testing code\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

import React, {
  useEffect,
  useMemo,
  useState,
  useCallback,
  useRef,
} from "react";
import {
  CustomInput,
  DevNote,
  InfoCardNewAdv,
  InfoTimeCardAdv,
  NewTable,
  NewTableAdv,
  PageHeader,
  PageTitle,
  TableAdv,
} from "../../../../../../../../components";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllEmpDeductions,
  setCurrentPayrollEditing,
} from "../../../../../../../../redux/slices/payroll/payrollSlice";
import { formatCurrency } from "../../../../../../../../utils/stringUtils";
import { fetchEmpDeduction } from "../../../../../../../../redux/slices/payroll/payrollApi";
import { showToastMessage } from "../../../../../../../../utils/toastUtil";
import dayjs from "dayjs";
import common from "../../../../../../../../utils/common";

const Deductions = ({ rowData, disableEditing = false,tab }) => {
  const { parseAmount } = common;
  const dispatch = useDispatch();

  // Add ref to prevent unnecessary API calls
  const hasInitialized = useRef(false);
  const lastEmployeeId = useRef(null);

  useEffect(() => {
    dispatch(
      setCurrentPayrollEditing({
        tabswitched: true,
      })
    );
  }, [dispatch]);

  const { currentPayrollEditing, empDeduction,loading } = useSelector(
    (state) => state.payRoll
  );
  console.log(loading)

  const employeeId = currentPayrollEditing?.employeeId?.uiid;

  // State management
  const [empDeductions, setEmpDeductions] = useState([]);
  const [healthTableData, setHealthTableData] = useState([]);
  const [h1bTableData, setH1bTableData] = useState([]);
  const [selectedHealthIds, setSelectedHealthIds] = useState([]);
  const [selectedH1bIds, setSelectedH1bIds] = useState([]);

  const deductions = Array.isArray(empDeductions) ? empDeductions : [];
  const reduxDeductions = currentPayrollEditing?.deductions || [];
  const reduxEmpDeductions = currentPayrollEditing?.empDeductions || [];

  // Get currently selected IDs from Redux - memoize properly
  const selectedDeductionIdsH1b = useMemo(() => {
    return reduxDeductions
      .filter((deduction) => deduction?.deductionType === 1)
      .map((deduction) => String(deduction?.id || deduction?._id));
  }, [reduxDeductions]);

  const selectedDeductionIdsHealth = useMemo(() => {
    return reduxDeductions
      .filter((deduction) => deduction?.deductionType === 2)
      .map((deduction) => String(deduction?.id || deduction?._id));
  }, [reduxDeductions]);

  // Group deductions by type - add proper memoization
  const groupedDeductions = useMemo(() => {
    return deductions.reduce((acc, deduction) => {
      const deductionType = Number(deduction.deductionType);
      if (!acc[deductionType]) acc[deductionType] = [];
      acc[deductionType].push(deduction);
      return acc;
    }, {});
  }, [deductions]);

  const regularInsurance = useMemo(
    () => groupedDeductions[1] || [],
    [groupedDeductions]
  );
  const healthInsurance = useMemo(
    () => groupedDeductions[2] || [],
    [groupedDeductions]
  );

  // Transform health insurance data - fix memoization
  const healthInsuranceFilter = useMemo(() => {
    return healthInsurance.flatMap((data) =>
      Array.isArray(data.installments)
        ? data.installments
        ?.filter((installment) => tab === "paid" ? installment.status === 2 : installment.status === 1)
        ?.map((installment) => ({
            ...installment,
            id: String(installment._id),
            deducted: installment.receivable,
            uiid: data.uiid,
            name: data.name,
            deductionAmountInput:
              installment.receivableExachange ??
              installment.received ??
              installment.receivable,
            deductionType: data?.deductionType,
          }))
        : []
    );
  }, [healthInsurance]);

  // Transform H1B insurance data - fix memoization
  const h1bInsuranceFilter = useMemo(() => {
    return regularInsurance.flatMap((data) =>
      Array.isArray(data.installments)
        ? data.installments.map((installment) => ({
            ...installment,
            amounts: data.amounts,
            id: String(installment._id),
            deducted: installment.receivable,
            uiid: data.uiid,
            name: data.name,
            deductionAmountLelf:
              installment.receivableExachange ??
              installment.received ??
              installment.receivable,
            deductionType: data?.deductionType,
          }))
        : []
    );
  }, [regularInsurance]);

  // Handle overflow logic - distribute excess amount to next deductions
  const handleOverflow = useCallback(
    (tableData, currentRowId, excessAmount) => {
      const currentIndex = tableData.findIndex(
        (row) => row.id === currentRowId
      );
      if (currentIndex === -1 || excessAmount <= 0) return tableData;

      let remainingExcess = excessAmount;
      const updatedData = [...tableData];

      // Start from the next row after current
      for (
        let i = currentIndex + 1;
        i < updatedData.length && remainingExcess > 0;
        i++
      ) {
        const nextRow = updatedData[i];
        const currentAmount = parseAmount(
          nextRow.deductionAmountLelf || nextRow.deductionAmountInput || 0
        );
        const maxAmount = parseAmount(nextRow.deducted || 0);
        const availableSpace = Math.max(0, maxAmount - currentAmount);

        if (availableSpace > 0) {
          const amountToAdd = Math.min(remainingExcess, availableSpace);
          const newAmount = currentAmount + amountToAdd;

          updatedData[i] = {
            ...nextRow,
            [nextRow.deductionAmountLelf !== undefined
              ? "deductionAmountLelf"
              : "deductionAmountInput"]: newAmount,
          };

          remainingExcess -= amountToAdd;
        }
      }

      return updatedData;
    },
    [parseAmount]
  );

  // Table columns for health insurance
  const healthColumns = useMemo(
    () => [
      { key: "name", label: "Deduction Type" },
      { key: "deducted", label: "Deduction Amount" },
      {
        key: "deductionAmountInput",
        label: "",
        render: (row) => (
          <CustomInput
            type="number"
            size="sm"
            value={row?.deductionAmountInput || ""}
            onChange={(e) => handleChangeTable("deductionAmountInput", row, e)}
            disabled={true} // Health insurance is disabled as per original code
            maxNumber={row?.deducted}
          />
        ),
      },
    ],
    []
  );

  // Table columns for H1B insurance
  const h1bColumns = useMemo(
    () => [
      {
        key: "name",
        label: "Deduction Type",
        showAccordianBtn: true,
        render: (row) => <div>{row.name}</div>,
      },
      {
        key: "Total",
        label: "Total Amount",
        render: (row) => {
          return <div>{formatCurrency(row?.amounts?.deducted)}</div>;
        },
      },
      {
        key: "TotalBalance",
        label: "Pending Balance",
        render: (row) => {
          return (
            <div>
              {formatCurrency(
                (row?.amounts?.deducted || 0) - (row?.amounts?.received || 0)
              )}
            </div>
          );
        },
      },
      {
        key: "TotalRecovered",
        label: "Recovered Amount",
        render: (row) => {
          return <div>{formatCurrency(row?.amounts?.received || 0)}</div>;
        },
      },
      {
        key: "deducted",
        label: "Installment Amount",
        render: (row) => <div>{formatCurrency(row?.deducted)}</div>,
      },
      {
        key: "deductionAmountLelf",
        label: "",
        width:"w-[150px]",
        render: (row) => (
          <div className="flex items-center">
            <CustomInput
              type="number"
              size="xs"
              value={row?.deductionAmountLelf || ""}
              onChange={(e) => handleChangeTable("deductionAmountLelf", row, e)}
              // maxNumber={row?.deducted}
              disabled={disableEditing}
            />
          </div>
        ),
      },
    ],
    [disableEditing]
  );

  const handleChangeTable = useCallback(
    (field, row, e) => {
      try {
        const rawValue = e?.target?.value ?? e;
        const numericValue = parseAmount(rawValue);
        const maxAmount = parseAmount(row?.deducted || 0);

        // What user typed (kept in UI)
        const uiValue = rawValue;

        // Internal capped value for calculations
        let cappedValue = numericValue;
        let excess = 0;

        if (numericValue > maxAmount) {
          cappedValue = maxAmount;
          excess = numericValue - maxAmount;
        }

        const updateTable = (setter, prev, type) => {
          const updated = prev.map((item) =>
            item.id === row.id ? { ...item, [field]: uiValue } : item
          );

          if (excess > 0) {
            const overflowed = handleOverflow(updated, row.id, excess);
            return overflowed;
          }

          return updated;
        };

        if (field === "deductionAmountInput") {
          setHealthTableData((prev) =>
            updateTable(setHealthTableData, prev, "health")
          );
        }

        if (field === "deductionAmountLelf") {
          setH1bTableData((prev) => updateTable(setH1bTableData, prev, "h1b"));
        }

        // Update master deductions with capped value
        setEmpDeductions((prev) =>
          prev.map((deduction) => {
            if (!Array.isArray(deduction.installments)) return deduction;
            return {
              ...deduction,
              installments: deduction.installments.map((inst) =>
                inst._id === row.id
                  ? { ...inst, receivableExachange: cappedValue }
                  : inst
              ),
            };
          })
        );
      } catch (err) {
        console.error("Error in handleChangeTable:", err);
        showToastMessage("error", "Failed to update the deduction amount");
      }
    },
    [parseAmount, handleOverflow]
  );

  // Fetch deductions from API
  const handleCallDeductions = useCallback(async () => {
    try {
      if (!employeeId || !rowData?.payCycle?.from || !rowData?.payCycle?.to) {
        console.warn("Missing required filter parameters");
        return;
      }

      let employeeIdToCall =
        rowData?.employeeId?.employmentType === 4
          ? rowData?.employeeId?.linkedTo
          : rowData?.employeeId?.uiid;
      console.log("from", rowData?.payCycle?.from, "to", rowData?.payCycle?.to);
      const params = {
        coll: "EmpDeduction",
        filters: {
          employeeId: { type: "NONE", value: employeeIdToCall },
          type: { type: "NONE", value: 1 },
          ...(tab !== "paid" && {stop: { type: "NONE", value: false }}),
          //mahendar code mot working
          // "installments.payCycle.from": {
          //   type: "GTE",
          //   value: dayjs(rowData?.payCycle?.from)
          //     .startOf("month")
          //     .toISOString(),
          // },
          // "installments.payCycle.to": {
          //   type: "LTE",
          //   value: dayjs(rowData?.payCycle?.to).endOf("month").toISOString(),
          // },
          //new code
          "installments.payCycle": {
            type: "RANGE",
            value: {
              from: rowData?.payCycle?.from,
              to: rowData?.payCycle?.to,
            },
          },
        },
      };

      const response = await fetchEmpDeduction(params);

      if (response.success) {
        console.log(response.data.data);
        const filteredData = response.data.data
          .map((deduction) => {
            const matchedInstallments = deduction.installments.filter(
              (inst) => {
                const from = new Date(inst.payCycle.from);
                const to = new Date(inst.payCycle.to);
                const filterFrom = new Date(rowData.payCycle.from);
                const filterTo = new Date(rowData.payCycle.to);

                return from <= filterTo && to >= filterFrom;
              }
            );

            if (matchedInstallments.length === 0) return null;

            return {
              ...deduction,
              installments: matchedInstallments,
            };
          })
          .filter(
            rowData?.employeeId?.employmentType !== 4
              ? Boolean
              : (ded) => ded.deductionType !== 2
          );

        setEmpDeductions(filteredData);

        // Auto-select health deductions if no existing selections
        if (
          reduxDeductions.length === 0 ||
          rowData?.employeeId?.employmentType !== 4
        ) {
          const healthDeductions = filteredData.filter(
            (d) => d.deductionType === 2
          );
          const dataHealth = healthDeductions.flatMap((data) =>
            Array.isArray(data.installments)
              ? data.installments
              ?.filter((installment) => tab === "paid" ? installment.status === 2 : installment.status === 1)
              ?.map((installment) => ({
                  ...installment,
                  id: String(installment._id),
                  deducted: installment.receivable,
                  uiid: data.uiid,
                  name: data.name,
                  deductionAmountInput: installment.receivable,
                  deductionType: data?.deductionType,
                }))
              : []
          );
          const allHealthInstallmentIds = dataHealth.map((item) =>
            String(item.id)
          );

          if (allHealthInstallmentIds.length > 0) {
            handleSelectDeductions(
              "health",
              allHealthInstallmentIds,
              dataHealth
            );
          }
        }
      } else {
        setEmpDeductions([]);
      }
    } catch (error) {
      console.error("Error fetching deductions:", error);
      showToastMessage("error", "Unable to load deductions");
    }
  }, [employeeId, rowData, reduxDeductions.length]);

  // Handle selection changes
  const handleSelectDeductions = useCallback(
    (type, selectedIds = [], sourceData = [], updatedEmpDeductions = []) => {
      let source = [];

      if (sourceData.length > 0) {
        source = sourceData;
      } else if (type === "health") {
        source = healthTableData;
      } else if (type === "h1b") {
        source = h1bTableData;
      }

      const normalizedSelectedIds = selectedIds.map((id) => String(id));
      const selectedMap = new Map();

      // Add newly selected items from source
      source.forEach((item) => {
        const itemId = String(item.id || item.uiid);
        if (normalizedSelectedIds.includes(itemId)) {
          selectedMap.set(itemId, item);
        }
      });

      // Retain items from Redux that are not from current source OR are still selected
      reduxDeductions.forEach((item) => {
        const itemId = String(item.id || item._id || item.uiid);
        const isFromCurrentSource = source.some(
          (s) => String(s.id || s.uiid) === itemId
        );

        if (!isFromCurrentSource || normalizedSelectedIds.includes(itemId)) {
          if (!selectedMap.has(itemId)) {
            selectedMap.set(itemId, item);
          }
        }
      });

      // Create final deductions array with updated amounts
      const finalDeductions = Array.from(selectedMap.values()).map((item) => {
        const itemId = String(item.id || item._id || item.uiid);
        const existingItem = reduxDeductions.find(
          (d) => String(d.id || d._id || d.uiid) === itemId
        );

        if (existingItem) {
          const oldAmount = parseAmount(
            existingItem.deductionAmountInput ??
              existingItem.deductionAmountLelf
          );
          const newAmount = parseAmount(
            item.deductionAmountInput ?? item.deductionAmountLelf
          );

          if (oldAmount !== newAmount) {
            return item; // Use updated item
          }
          return existingItem; // Keep existing item
        }
        return item; // New item
      });

      // Check if anything actually changed
      const hasChanged = checkForChanges(reduxDeductions, finalDeductions);

      if (hasChanged) {
        const totalDeductionsAmount = finalDeductions.reduce((sum, item) => {
          const amount = parseAmount(
            item.deductionAmountInput ?? item.deductionAmountLelf
          );
          return sum + amount;
        }, 0);

        const oldDeductionAmount = reduxDeductions.reduce((sum, item) => {
          const amount = parseAmount(
            item.deductionAmountInput ?? item.deductionAmountLelf
          );
          return sum + amount;
        }, 0);
        console.log({oldDeductionAmount,totalDeductionsAmount});
        const difference=
          (currentPayrollEditing?.difference || 0) -
          oldDeductionAmount +
          totalDeductionsAmount;

        dispatch(
          setCurrentPayrollEditing({
            ...currentPayrollEditing,
            deductions: finalDeductions,
            difference : tab === "paid" ? rowData?.amounts?.diff : difference,
            totalDeductionsAmount,
            empDeductions:
              updatedEmpDeductions.length > 0
                ? updatedEmpDeductions
                : empDeductions,
          })
        );
      }
    },
    [
      healthTableData,
      h1bTableData,
      reduxDeductions,
      empDeductions,
      currentPayrollEditing,
      dispatch,
      parseAmount,
    ]
  );

  // Helper function to check for changes
  const checkForChanges = useCallback(
    (oldDeductions, newDeductions) => {
      if (oldDeductions.length !== newDeductions.length) {
        return true;
      }

      const oldMap = new Map(
        oldDeductions.map((d) => [String(d.id || d._id || d.uiid), d])
      );

      for (const newItem of newDeductions) {
        const id = String(newItem.id || newItem._id || newItem.uiid);
        const oldItem = oldMap.get(id);

        if (!oldItem) {
          return true;
        }

        const oldAmount = parseAmount(
          oldItem.deductionAmountInput ?? oldItem.deductionAmountLelf
        );
        const newAmount = parseAmount(
          newItem.deductionAmountInput ?? newItem.deductionAmountLelf
        );

        if (oldAmount !== newAmount) {
          return true;
        }
      }

      return false;
    },
    [parseAmount]
  );

  // Handle health insurance selection
  const handleHealthSelectionChange = useCallback(
    (selectedIds) => {
      const normalizedIds = selectedIds.map((id) => String(id));
      const sortedNew = [...normalizedIds].sort();
      const sortedOld = [...selectedHealthIds].sort();

      if (JSON.stringify(sortedNew) !== JSON.stringify(sortedOld)) {
        setSelectedHealthIds(normalizedIds);
        handleSelectDeductions("health", normalizedIds);
      }
    },
    [selectedHealthIds, handleSelectDeductions]
  );

  // Handle H1B selection
  const handleH1bSelectionChange = useCallback(
    (selectedIds) => {
      const normalizedIds = selectedIds.map((id) => String(id));
      const sortedNew = [...normalizedIds].sort();
      const sortedOld = [...selectedH1bIds].sort();

      if (JSON.stringify(sortedNew) !== JSON.stringify(sortedOld)) {
        setSelectedH1bIds(normalizedIds);
        handleSelectDeductions("h1b", normalizedIds);
      }
    },
    [selectedH1bIds, handleSelectDeductions]
  );

  // Calculate totals
  const totalHealthDeduction = useMemo(() => {
    return reduxDeductions
      .filter((data) => data.deductionType === 2)
      .reduce((acc, data) => {
        const amount = parseAmount(data.deductionAmountInput || 0);
        return acc + amount;
      }, 0);
  }, [reduxDeductions, parseAmount]);

  const totalH1bDeduction = useMemo(() => {
    return reduxDeductions
      .filter((data) => data.deductionType === 1)
      .reduce((acc, data) => {
        const amount = parseAmount(data.deductionAmountLelf || 0);
        return acc + amount;
      }, 0);
  }, [reduxDeductions, parseAmount]);

  // FIXED: Initial data loading effect
  useEffect(() => {
    if (!employeeId) return;

    // Only initialize once per employee or when employee changes
    if (employeeId !== lastEmployeeId.current) {
      lastEmployeeId.current = employeeId;
      hasInitialized.current = false;
    }

    if (!hasInitialized.current) {
      hasInitialized.current = true;

      if (reduxEmpDeductions.length > 0) {
        setEmpDeductions(reduxEmpDeductions);
      } else {
        handleCallDeductions();
      }
    }
  }, [employeeId, reduxEmpDeductions.length, handleCallDeductions]);

  // FIXED: Update table data only when source data changes significantly
  useEffect(() => {
    if (healthInsuranceFilter.length > 0) {
      setHealthTableData((prevData) => {
        // Only update if there's a significant change (different length or different IDs)
        if (prevData.length === 0) {
          return healthInsuranceFilter;
        }

        const prevIds = prevData.map((item) => item.id).sort();
        const newIds = healthInsuranceFilter.map((item) => item.id).sort();

        // Only update if IDs are different
        if (JSON.stringify(prevIds) !== JSON.stringify(newIds)) {
          return healthInsuranceFilter.map((newItem) => {
            const existing = prevData.find((item) => item.id === newItem.id);
            return existing || newItem;
          });
        }

        return prevData;
      });
    }
  }, [
    healthInsuranceFilter.length,
    healthInsuranceFilter.map((item) => item.id).join(","),
  ]);

  useEffect(() => {
    if (h1bInsuranceFilter.length > 0) {
      setH1bTableData((prevData) => {
        // Only update if there's a significant change
        if (prevData.length === 0) {
          return h1bInsuranceFilter;
        }
        const prevIds = prevData.map((item) => item.id).sort();
        const newIds = h1bInsuranceFilter.map((item) => item.id).sort();

        // Only update if IDs are different
        if (JSON.stringify(prevIds) !== JSON.stringify(newIds)) {
          return h1bInsuranceFilter.map((newItem) => {
            const existing = prevData.find((item) => item.id === newItem.id);
            return existing || newItem;
          });
        }

        return prevData;
      });
    }
  }, [
    h1bInsuranceFilter.length,
    h1bInsuranceFilter.map((item) => item.id).join(","),
  ]);

  // FIXED: Update local selected IDs only when Redux actually changes
  useEffect(() => {
    const sortedReduxHealth = [...selectedDeductionIdsHealth].sort();
    const sortedLocalHealth = [...selectedHealthIds].sort();

    if (
      JSON.stringify(sortedReduxHealth) !== JSON.stringify(sortedLocalHealth)
    ) {
      setSelectedHealthIds(selectedDeductionIdsHealth);
    }
  }, [selectedDeductionIdsHealth.join(",")]);

  useEffect(() => {
    const sortedReduxH1b = [...selectedDeductionIdsH1b].sort();
    const sortedLocalH1b = [...selectedH1bIds].sort();

    if (JSON.stringify(sortedReduxH1b) !== JSON.stringify(sortedLocalH1b)) {
      setSelectedH1bIds(selectedDeductionIdsH1b);
    }
    // console.log(
    //   "selectedDeductionIdsH1b",
    //   selectedDeductionIdsH1b,
    //   selectedH1bIds
    // );
  }, [selectedDeductionIdsH1b.join(",")]);

  return (
    <div className="p-4">
      <div className="mt-3">
        {
          rowData.employeeId?.employmentType !== 4 && (<>
            <PageHeader
              Section={<PageTitle title="Health Insurance" />}
              RightSection={
                <>
                <InfoCardNewAdv
                  layout="option12"
                  title="Insurance Deductions"
                  value={formatCurrency(totalHealthDeduction)}
                  valueConfig={{ className: "text-[28px]!" }}
                  isLoading={loading}
                />
                  </>
              }
            />
            <div className="mt-2">
              <NewTableAdv
                showCheckbox
                rows={healthTableData}
                columns={healthColumns}
                hideToolBar
                disableSelection={disableEditing}
                defaultCheckBox={true}
                defaultSelectedRows={selectedDeductionIdsHealth}
                onSelectionChange={handleHealthSelectionChange}
              />
            </div>
          </>)
          }
        <div className="mt-4">
          <PageHeader
            Section={<PageTitle title="Regular Deductions" />}
            RightSection={
              <>
              {/* <InfoTimeCardAdv
                title="Deductions"
                color="primary"
                value={formatCurrency(totalH1bDeduction)}
                type2
                /> */}
                <InfoCardNewAdv
                  layout="option12"
                  title="Deductions"
                  value={formatCurrency(totalH1bDeduction)}
                  valueConfig={{ className: "text-[28px]!" }}
                  isLoading={loading}
                />
                </>
            }
          />
        </div>
        <DevNote>
          <>
            {selectedDeductionIdsH1b}
            <div>Id's are: {selectedDeductionIdsH1b.join(", ")}</div>
          </>
        </DevNote>
        {console.log({selectedDeductionIdsH1b})}
        <div className="mt-3">
          {/* <NewTable*/}
          <TableAdv
            showCheckbox
            rows={h1bTableData}
            columns={h1bColumns}
            hideToolBar
            defaultSelectedRows={selectedDeductionIdsH1b}
            // defaultSelectedRows={currentPayrollEditing?.deductions?.map((item) => item._id)}
            disableSelection={disableEditing}
            onSelectionChange={handleH1bSelectionChange}
            toolbarRight={{
              search: false,
              filter: false,
              download: false,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Deductions;
